import { Box, Image, Link } from "@drone-js/core";
import { useUrlBuilder } from "apps/commons/hooks/useUrlBuilder";
import { LanguageSwitcher } from "libs/languageSwitcher";

import type { FunctionComponent } from "react";

const AgodaLogo: FunctionComponent = () => {
    const urlBuilder = useUrlBuilder();

    return (
        <Box py="8" flexShrink={0}>
            <Link href={urlBuilder.agodaHomesUrl()}>
                <Image
                    src="https://cdn6.agoda.net/images/kite-js/logo/agoda/color-default.svg"
                    alt="Agoda"
                    height="32px"
                    width="62.219px"
                    loading="immediate"
                />
            </Link>
        </Box>
    );
};

export const Header: FunctionComponent = () => {
    return (
        <Box
            as="nav"
            borderWidth={["0", "0", "1"]}
            borderColor="base.default"
            backgroundColor="base.surface"
            borderStyle="solid"
            width="100%"
            zIndex={99}
        >
            <Box display="flex" py="8" px="16" width="100%" justifyContent="space-between" qM={{ px: "32" }}>
                <AgodaLogo data-test-id="agoda-logo" />
                <Box display="flex" gap="24">
                    <LanguageSwitcher
                        languageFlagElementName="select-language"
                        languageFlagSelectorElementName="language-selector-link"
                    />
                </Box>
            </Box>
        </Box>
    );
};
